import { useMemo, useState } from "react";
import {
  Table,
  ScrollArea,
  Group,
  Text,
  ActionIcon,
  Avatar,
  Title,
} from "@mantine/core";
import { Edit, Eye, Trash } from "tabler-icons-react";
import { sortData } from "../../../utils/tableActions";
import Th from "../../../components/Th";
import { useNavigate } from "react-router-dom";

export default function BulletinDiagnostiqueClasseTable({ data }) {
  const [sortedData, setSortedData] = useState(data);
  const [sortBy, setSortBy] = useState(null);
  const [reverseSortDirection, setReverseSortDirection] = useState(false);

  const navigation = useNavigate();

  const setSorting = (field) => {
    const reversed = field === sortBy ? !reverseSortDirection : false;
    setReverseSortDirection(reversed);
    setSortBy(field);
    setSortedData(sortData(data, { sortBy: field, reversed, search: "" }));
  };

  useMemo(() => {
    setSortedData(data);
  }, [data]);

  const rows = sortedData.map((row) => (
    <tr key={row?.id}>
      <td>
        <Group>
          <Avatar color="blue" radius={"50%"}>
            {row?.firstName?.at(0)}
            {row?.lastName?.at(0)}
          </Avatar>
          <Text weight={600}>
            {row?.firstName} {row?.lastName}
          </Text>
        </Group>
      </td>
      <td>{row?.school?.name}</td>
      {/* <td>
        <Title order={4}>2</Title>
      </td> */}
      <td>
        <Group position="right">
          <ActionIcon color="blue" onClick={() => navigation(`${row?.id}`)}>
            <Eye size={18} />
          </ActionIcon>
          {/* <ActionIcon color="green">
            <Edit size={18} />
          </ActionIcon> */}
          {/* <ActionIcon>
            <Trash size={18} color="red" />
          </ActionIcon> */}
        </Group>
      </td>
    </tr>
  ));

  return (
    <ScrollArea>
      <Table
        horizontalSpacing="md"
        verticalSpacing="xs"
        miw={700}
        sx={{ tableLayout: "fixed" }}
        bg={"#fff"}
      >
        <thead>
          <tr>
            <Th
              sorted={sortBy === "firstName"}
              reversed={reverseSortDirection}
              onSort={() => setSorting("firstName")}
            >
              Eleves
            </Th>
            <Th
              sorted={sortBy === "ecole"}
              reversed={reverseSortDirection}
              onSort={() => setSorting("ecole.name")}
            >
              Ecoles
            </Th>
            {/* <Th
              sorted={sortBy === "boursier"}
              reversed={reverseSortDirection}
              onSort={() => setSorting("boursier")}
            >
              Nombre de fois
            </Th> */}
            <th style={{ textAlign: "right" }}>action</th>
          </tr>
        </thead>
        <tbody>
          {rows.length > 0 ? (
            rows
          ) : (
            <tr>
              <td>
                <Text weight={500} align="center">
                  Nothing found
                </Text>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </ScrollArea>
  );
}
